module.exports = __webpack_public_path__ + "static/media/muttonrogani.0d44306d.jpg";